// @flow
import { h } from 'preact';
import { styled } from 'goober';
import { useState, useEffect } from 'preact/hooks';
import MuiInput from '../../material-ui/muiInput';
import SaCustomButton from '../SaCustomButton';
import {
  useSalesContext,
  useSalesDispatchContext,
} from '../../../storeProviders/salesAppStore';
import {
  salesCheckEligibility,
  salesGetEmiDetails,
} from '../../../api/controllers/salesController';
import { useRequest } from '../../../api/services/useRequest';
import { route } from 'preact-router';
import {
  salesLenderDetailsRoute,
  salesLendersListsRoute,
} from '../../../alias/salesAppRoutes';
import useSalesAppError from '../hooks/useSalesAppError';
import { currencyFormat } from '../../directives/currencyFormat';
import saRoute from '../../salesApp/constants/saRoute';
import { useSalesAppTracker } from '../tracker';
import useKeyEnter from '../../../hooks/useKeyEnter';

const Container = styled('div')`
  .container {
    padding: 50px 16px 30px 16px;
  }
  .heading {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--primaryCTAColor);
  }
  .btnSection {
    width: 318px;
    height: 50px;
    margin: 0 auto;
    background-color: var(--primaryCTAColor);
    border-radius: 8px;
    border-color: transparent;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1px;
    color: #ffffff;
    text-transform: capitalize;
  }
  .btnContainer {
    margin: 45px 0px 0px;
    display: flex;
    justify-content: center;
  }
  .feError {
    color: #c8260f;
    font-size: 12px;
    margin-top: 10px;
    font-weight: 500;
  }
  .secondaryBtn {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1px;
    text-decoration-line: underline;
    color: #1a73e8;
    margin-top: 20px;
    cursor: pointer;
  }
`;
const AmountContainer = styled('div')`
  .mdc-text-field--outlined .mdc-floating-label {
    border-color: #000000;
  }
  .rupeesSymbolPrefix {
    position: absolute;
    z-index: 1;
    display: inline-block;
    height: 24px;
    padding: 4px 4px 0px 15px;
    text-align: center;
    top: 11px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
  }
  .amountInputWrapper {
    margin-top: 24px;
    position: relative;
  }
  .amountInputWrapper input {
    text-align: left !important;
    padding-left: 30px !important;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
  }
`;
const EnterAmount = () => {
  const pageKey = 'sa_pv_txn_amt_modal';
  const [amount, setAmount] = useState({ amountValue: '' });
  const [prefix, showPrefix] = useState(false);
  const salesState = useSalesContext();
  const salesDispatch = useSalesDispatchContext();
  const salesAppTracker = useSalesAppTracker(pageKey);
  const checkEligibilityRequest = useRequest();
  const getEmiDetailsRequest = useRequest();
  const {
    mobile,
    prevAmount,
    selectedLenderId,
    routeDetails,
    singleFunctionality,
  } = salesState;
  const [feError, setFeError] = useState();
  const { amountValue } = amount;
  const { selectedModule, selectedLenderDetails } = salesState || {};
  const { minLoanAmount, maxLoanAmount } = selectedLenderDetails || {};
  const { path } = routeDetails;
  const [amountError, setAmountError] = useState({
    show: false,
    errorType: null,
    tempAmount: null,
  });

  const { setSalesAppErrorModal } = useSalesAppError();

  const closeBottomSheet = () => {
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        bottomSheetConfig: {
          showOverlay: false,
          moduleName: null,
        },
      },
    });
  };
  const btnHandler = (checkAmountRange) => {
    if (parseInt(amount.amountValue) <= 0) {
      setFeError(true);
    } else {
      if (amount.amountValue) {
        if (
          checkAmountRange &&
          minLoanAmount &&
          minLoanAmount > amount.amountValue
        ) {
          setAmountError({
            show: true,
            errorType: 'MIN',
            tempAmount: amount.amountValue,
          });
        } else if (
          checkAmountRange &&
          maxLoanAmount &&
          maxLoanAmount < amount.amountValue
        ) {
          setAmountError({
            show: true,
            errorType: 'MAX',
            tempAmount: amount.amountValue,
          });
        } else {
          setAmountError({
            show: false,
            errorType: null,
            tempAmount: null,
          });

          if (mobile) {
            if (
              prevAmount !== amountValue &&
              (path !== '/sales-emi-home' && path !== '/sales-app-init')
            ) {
              salesCheckEligibility(checkEligibilityRequest.makeRequest, {
                mobile,
                amount: amountValue,
              });
            } else {
              closeBottomSheet();
            }
          }
          if (selectedModule === 'EMI_CALCULATOR') {
            salesAppTracker.trackPageView('sa_pv_emi_calculator_module');
            if (path === '/sales-emi-home' || path === '/sales-app-init') {
              salesDispatch({
                type: 'STORE_STATE',
                payload: {
                  amount: amount.amountValue,
                  submittedAmount: '',
                  bottomSheetConfig: {
                    showOverlay: false,
                    moduleName: null,
                  },
                },
              });
              saRoute(salesLendersListsRoute.path, singleFunctionality);
            } else {
              if (!mobile) {
                if (prevAmount !== amountValue) {
                  salesGetEmiDetails(getEmiDetailsRequest.makeRequest, {
                    amount: amountValue,
                  });
                } else {
                  closeBottomSheet();
                }
              }
            }
          }
        }
      }
    }
  };

  useKeyEnter(() => {
    if (amount.amountValue.length !== 0) {
      btnHandler(path === '/sales-lender-details');
    }
  });

  useEffect(() => {
    salesAppTracker.trackPageView('sa_pv_txn_amt_modal');
  }, []);
  useEffect(() => {
    if (checkEligibilityRequest.value) {
      salesAppTracker.trackPageView('sa_pv_check_eligibility_success');
      const emiLenders = checkEligibilityRequest.value.emiLenders || [];
      const ntbLenders = checkEligibilityRequest.value.ntbLenders || [];
      const lenders = emiLenders.concat(ntbLenders);
      const selectedLenderDetails = lenders.filter(
        (lender) => lender.lenderId === selectedLenderId,
      )[0];
      salesDispatch({
        type: 'STORE_STATE',
        payload: {
          checkEligibilityResponse: checkEligibilityRequest.value,
          amount: amount.amountValue,
          prevAmount: amount.amountValue,
          selectedLenderDetails: selectedLenderDetails,
          submittedAmount: '',
        },
      });
      path === '/sales-emi-home' && route(salesLendersListsRoute.path);
      if (selectedLenderId) {
        if (
          selectedLenderDetails &&
          selectedLenderDetails.emiPlans &&
          selectedLenderDetails.emiPlans.length > 0
        ) {
          closeBottomSheet();
          path !== '/sales-lender-details' &&
            route(salesLenderDetailsRoute.path);
        } else {
          if (path === '/sales-lender-details') {
            closeBottomSheet();
            window.history.back();
          } else {
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                bottomSheetConfig: {
                  showOverlay: true,
                  moduleName: 'MIN_AMOUNT_NOT_MATCH',
                },
              },
            });
          }
        }
      } else {
        closeBottomSheet();
      }
    }
  }, [checkEligibilityRequest.value]);

  useEffect(() => {
    if (getEmiDetailsRequest.value) {
      const emiLenders = getEmiDetailsRequest.value.emiLenders || [];
      const selectedLenderDetails = emiLenders.filter(
        (lender) => lender.lenderId === selectedLenderId,
      )[0];

      if (selectedLenderId) {
        if (
          selectedLenderDetails &&
          selectedLenderDetails.emiPlans &&
          selectedLenderDetails.emiPlans.length > 0
        ) {
          salesDispatch({
            type: 'STORE_STATE',
            payload: {
              getEmiDetailsResponse: getEmiDetailsRequest.value,
              amount: amount.amountValue,
              prevAmount: amount.amountValue,
              selectedLenderDetails: selectedLenderDetails,
              bottomSheetConfig: {
                showOverlay: false,
              },
            },
          });
          path !== '/sales-lender-details' &&
            route(salesLenderDetailsRoute.path);
        } else {
          salesDispatch({
            type: 'STORE_STATE',
            payload: {
              amount: amount.amountValue,
              prevAmount: amount.amountValue,
              bottomSheetConfig: {
                showOverlay: false,
                moduleName: null,
              },
            },
          });
          path !== '/sales-lenders-list' && window.history.back();
        }
      } else {
        salesDispatch({
          type: 'STORE_STATE',
          payload: {
            getEmiDetailsResponse: getEmiDetailsRequest.value,
            amount: amount.amountValue,
            prevAmount: amount.amountValue,
            bottomSheetConfig: {
              showOverlay: false,
              moduleName: null,
            },
          },
        });
      }
    }
  }, [getEmiDetailsRequest.value]);

  useEffect(() => {
    if (checkEligibilityRequest.error) {
      setSalesAppErrorModal({
        ...checkEligibilityRequest.error,
        isRetryAllowed: true,
      });
    }
  }, [checkEligibilityRequest.error]);

  useEffect(() => {
    if (getEmiDetailsRequest.error) {
      setSalesAppErrorModal({
        ...getEmiDetailsRequest.error,
        isRetryAllowed: true,
      });
    }
  }, [getEmiDetailsRequest.error]);

  return (
    <Container>
      <div className='container'>
        <div className='heading'>Enter Transaction Amount</div>
        <AmountContainer>
          <div className='amountInputWrapper'>
            {(prefix || amount.amountValue) && (
              <span className='rupeesSymbolPrefix'>₹</span>
            )}
            <MuiInput
              className='mdc-text-field--focused'
              label='Amount'
              autoFocus
              type='tel'
              outlined
              inputName='amount'
              inputID='amount'
              elementName='amount'
              maxLength={7}
              inputValue={
                amount.amountValue && currencyFormat(amount.amountValue)
              }
              onfocusin={() => showPrefix(true)}
              onfocusout={() => !amount.amountValue && showPrefix(false)}
              onChange={(e) => {
                const amount = e.target.value;
                salesAppTracker.trackClick(
                  'sa_click_submit_txn_amt',
                  undefined,
                );
                setAmount({
                  amountValue: amount ? amount.replace(/[^0-9]/g, '') : '',
                });
                feError && setFeError(false);
              }}
            />
          </div>
          {feError && <div className='feError'>Please enter valid amount</div>}
          {amountError && amountError.show && (
            <div className='feError'>
              {amountError.errorType && amountError.errorType === 'MIN'
                ? `Please update the amount with min of ₹${currencyFormat(
                    minLoanAmount,
                  )}`
                : `Please update the amount with max upto ₹${currencyFormat(
                    maxLoanAmount,
                  )}`}
            </div>
          )}
        </AmountContainer>
        <SaCustomButton
          id='sa-app-btn'
          disable={amount.amountValue.length === 0}
          onClick={() => btnHandler(path === '/sales-lender-details')}
          loading={
            checkEligibilityRequest.loading || getEmiDetailsRequest.loading
          }
          name='Calculate EMI'
          containerClass='btnContainer'
        />
        {amountError && amountError.show && (
          <div className='secondaryBtn' onClick={() => btnHandler(false)}>
            {`Show available lenders for ₹${currencyFormat(
              amountError.tempAmount,
            )}`}
          </div>
        )}
      </div>
    </Container>
  );
};
export default EnterAmount;



// WEBPACK FOOTER //
// ./components/salesApp/common/EnterAmount.js